import { gql } from '@apollo/client'

export default gql`
  query GetNotifications {
    notifications {
      id
      message
      read
      updatedAt
    }
  }
`
